import GET_DIDS_FOR_API_KEY from '../gql/getDidsForApiKey.gql';
import GET_DIDS_FOR_SWITCH from '../gql/getDidsForSwitch.gql';
import { API_KEY_ANCHOR } from '../components/ChangeDidApiKeyForm';
import { SWITCH_ANCHOR } from '../components/ChangeDidSwitchForm';

/** The two resources a number can be attached to, and how to look up its numbers. */
export const DID_RESOURCES = {
  apiKey: {
    query: GET_DIDS_FOR_API_KEY,
    connection: 'didsForApiKey',
    // The number's Update tab form to jump to when moving it
    moveAnchor: API_KEY_ANCHOR,
  },
  switch: {
    query: GET_DIDS_FOR_SWITCH,
    connection: 'didsForSwitch',
    moveAnchor: SWITCH_ANCHOR,
  },
} as const;

export type DidResource = keyof typeof DID_RESOURCES;
